import React, { useState } from "react";
import { Container, Row, Col, Collapse } from "react-bootstrap";
import Steps from "components/Steps/Steps";
import Chart from "assets/images/chart.png";
import ScreenContent1 from "assets/images/screen-content-1.png";
import ScreenContent2 from "assets/images/screen-content-2.png";
import Logo1 from "assets/images/logos_apple-app-store.png";
import Logo2 from "assets/images/logos_apple-app-store2.png";
import Logo3 from "assets/images/logos_apple-app-store3.png";
import HeroSection from "components/common/sections/HeroSection";
import TryDemoSection from "components/common/sections/TryDemoSection";
import PricingSection from "components/common/sections/PricingSection";
// import BlogSection from 'components/common/sections/BlogSection';
import FAQSection from "components/common/sections/FAQSection";
import "./Landing.css";
import { useDispatch, useSelector } from "react-redux";
import { showSteps } from "actions/ui_control";

function Landing() {
  // It was unclear whether to make the text collapse/expand independent of each other,
  // or to collapse other texts when one text is expanded.
  // So for now, I implemented the second option.
  const [expandedTextOrder, setExpandedTextOrder] = useState(1);
  const { isShowSteps } = useSelector(state => state.ui_control);

  const dispatch = useDispatch();

  const showStepsFunc = () => {
    dispatch(showSteps());
  };
  return (
    <>
      {/* Hero section */}
      <HeroSection />

      {/* How-it-works section */}
      <section id="hiw-section">
        <Container>
          <Row className="d-flex justify-content-center py-3">
            <Col className="col-12 text-center my-auto mb-lg-auto">
              {/*<h3 className="mb-4 mt-4">How it works?</h3>*/}
              <h1 className="mb-5">Intelligent Investing</h1>
            </Col>
            <Col className="col-12 col-lg-4 px-5 text-center">
              <img src={Logo1} alt="" />
              <h3 className="mb-3 mt-3">Register</h3>
              <p>Set your plan to automatic</p>
            </Col>
            <Col className="col-12 col-lg-4 px-5 text-center">
              <img src={Logo2} alt="" />
              <h3 className="mb-3 mt-3">Instruct</h3>
              <p>Add your plan details</p>
            </Col>
            <Col className="col-12 col-lg-4 px-5 text-center">
              <img src={Logo3} alt="" />
              <h3 className="mb-3 mt-3">Wealth</h3>
              <p>Sit back, while Servus follows your plan</p>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Try-Demo section */}
      <section id="try-demo-section">
        <Container>
          <Row
            className="justify-content-center align-items-center p-5"
            style={{ minHeight: "400px" }}
          >
            <Col className="text-center">
              {/* {isShowSteps && <Steps />} */}
              <h2 className="mb-4">Let's do a Demo?</h2>
              <p className="large-p mb-4">
                See how our instruction form makes everything easy.
              </p>
              <button
                style={{ width: "153px", height: "48px" }}
                className="btn button-purple-gradient mb-2 me-2"
                onClick={showStepsFunc}
              >
                Try Demo
              </button>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Pricing section */}
      <PricingSection />

      {/* Why Us section */}
      <section id="whyus-section">
        <Container className="mt-5">
          <Row>
            <Col sm={12} className="text-center mb-2 mb-lg-4">
              {/*<h3 className="mb-3">Advantage</h3>*/}
              <h3>Why Servus</h3>
            </Col>
            <Col sm={12} lg={6} className="d-none d-lg-block">
              <img className="img-fluid" src={Chart} alt="" />
            </Col>
            <Col sm={12} lg={6} className="">
              <div className="m-1 m-lg-3 m-xl-5 p-4 white-card">
                <h2>Wealth creation made simple and effortless.</h2>
                <p>
                  Automating your plan, keeping you on track to invest without
                  taking up your time. Servus follows and invests based on your
                  instructions.
                </p>
                <div className="mt-4">
                  <h4 style={{ clear: "both" }}>
                    Monitor & Invest:
                    <i
                      className={`bi bi-arrow-${
                        expandedTextOrder === 1 ? "up" : "down"
                      }-circle button-expand`}
                      onClick={() =>
                        setExpandedTextOrder(expandedTextOrder === 1 ? 0 : 1)
                      }
                    ></i>
                  </h4>
                  <Collapse in={expandedTextOrder === 1}>
                    <div id="collapse-text">
                      <p style={{ color: "#03001C99" }}>
                        Give us your instructions and our systems will monitor,
                        alert, and invest for you. No more watching or missing
                        investing opportunities.
                      </p>
                    </div>
                  </Collapse>
                </div>
                <div className="mt-4">
                  <h4 style={{ clear: "both" }}>
                    Multiple Accounts:
                    <i
                      className={`bi bi-arrow-${
                        expandedTextOrder === 2 ? "up" : "down"
                      }-circle button-expand`}
                      onClick={() =>
                        setExpandedTextOrder(expandedTextOrder === 2 ? 0 : 2)
                      }
                    ></i>
                  </h4>
                  <Collapse in={expandedTextOrder === 2}>
                    <div id="collapse-text">
                      <p style={{ color: "#03001C99" }}>
                        Our systems will invest, based on your instructions, in
                        multiple accounts. No more multiple logins and
                        instructions, let our systems make it simple.
                      </p>
                    </div>
                  </Collapse>
                </div>
                <div className="mt-4">
                  <h4 style={{ clear: "both" }}>
                    Emotional biases:
                    <i
                      className={`bi bi-arrow-${
                        expandedTextOrder === 3 ? "up" : "down"
                      }-circle button-expand`}
                      onClick={() =>
                        setExpandedTextOrder(expandedTextOrder === 3 ? 0 : 3)
                      }
                    ></i>
                  </h4>
                  <Collapse in={expandedTextOrder === 3}>
                    <div id="collapse-text">
                      <p style={{ color: "#03001C99" }}>
                        No human emotions leads to consistent investing
                        irrespective of market upswing or downswing. If your
                        instructions are met the system will invest for you.
                      </p>
                    </div>
                  </Collapse>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Screen 1 section */}
      <section id="screen-1-section">
        <Container fluid className="mb-5 mt-5">
          <Row>
            <Col sm={1} md={2} className="d-none d-md-block"></Col>
            <Col
              sm={12}
              md={5}
              className="d-flex align-items-center text-left ps-5 bg-white"
            >
              <div>
                <h2 style={{ textAlign: "left" }}>Take control of your time</h2>
                <p
                  className="large-p"
                  style={{ textAlign: "left", color: "#000000cc" }}
                >
                  Our systems give you back your time by automating your
                  investment plan without you having to lift a finger. No missed
                  opportunities, just more time to enjoy what you love.
                  <br />
                  Let our system monitor and purchase your chosen stocks.
                </p>
                <h4 style={{ display: "inline-flex" }}>
                  Read more
                  <i
                    className="bi bi-arrow-right-circle ml-4"
                    style={{ fontSize: "1.5rem", marginLeft: "15px" }}
                  ></i>
                </h4>
              </div>
            </Col>
            <Col sm={12} md={5} className="px-0 d-flex flex-column bg-white">
              <div className="flex-grow-1">
                <img
                  style={{ float: "right" }}
                  className="img-fluid"
                  src={ScreenContent1}
                  alt=""
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Screen 2 section */}
      <section id="screen-2-section">
        <Container fluid>
          <Row>
            <Col sm={12} md={5} className="px-0 d-flex flex-column bg-white">
              <div className="flex-grow-1">
                <img
                  style={{ float: "left" }}
                  className="img-fluid"
                  src={ScreenContent2}
                  alt=""
                />
              </div>
            </Col>
            <Col
              sm={12}
              md={5}
              className="d-flex align-items-center text-left pe-5 bg-white"
            >
              <div>
                <h2 style={{ textAlign: "left" }}>
                  Simplify your investment tracking
                </h2>
                <p
                  className="large-p"
                  style={{ textAlign: "left", color: "#000000cc" }}
                >
                  With our platforms easy to use interface, you can track your
                  instructions easily. Add, Delete, Pause or see performance
                  with a click of the button.
                </p>
                <h4 style={{ display: "inline-flex" }}>
                  Read more
                  <i
                    className="bi bi-arrow-right-circle ml-4"
                    style={{ fontSize: "1.5rem", marginLeft: "15px" }}
                  ></i>
                </h4>
              </div>
            </Col>
            <Col sm={1} md={2} className="d-none d-md-block"></Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/*/!* Blog section *!/*/}
      {/*<BlogSection />*/}

      {/* FAQ section */}
      <FAQSection />

      {/* Try Demo section */}
      <TryDemoSection />
    </>
  );
}

export default Landing;
